// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-placeholder::placeholder {
	text-transform: capitalize;
}

.textfield-disabled:disabled {
	background-color: red;
	color: #8e8e8e;
	border: none;
	cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/text-field.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,YAAY;CACZ,mBAAmB;AACpB","sourcesContent":[".custom-placeholder::placeholder {\n\ttext-transform: capitalize;\n}\n\n.textfield-disabled:disabled {\n\tbackground-color: red;\n\tcolor: #8e8e8e;\n\tborder: none;\n\tcursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
